var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ColorTextBtn',{staticClass:"line inline-block",attrs:{"size":"mini","type":"primary"},on:{"click":_vm.to}},[_vm._v("编辑")])}
var staticRenderFns = []

export { render, staticRenderFns }